// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HsQb","field":"styles_field__43vl0","fieldCol":"styles_fieldCol___p7qG","diffCol":"styles_diffCol__2VBb7","diff":"styles_diff__2P7Eb"};